import { Paper } from '@mui/material';
import { useChatContext } from '../../contexts/chat/chat.context';
import { useChatMessagesStyles } from './chatMessages.styles';
import ChatMessageView from './components/ChatMessageView/ChatMessageView';
import EditChatView from './components/EditChatView/EditChatView';
import {
  ChatMessagesContextProvider,
  useChatMessagesContext,
} from './contexts/chatMessages.context';
import { ChatMessageViewEnum } from './contexts/reducer/chatMessages.state.types';

const ChatMessages = () => {
  const { currentView, currentChat } = useChatMessagesContext();

  const isEditingChat = currentView === ChatMessageViewEnum.EDIT_CHAT;

  const { classes } = useChatMessagesStyles({
    isEditingChat,
  });

  return (
    <Paper className={classes.root} test-id="chat-message-views-wrapper">
      <div className={classes.chatMessageViewWrapper} test-id="chat-message-view-wrapper">
        <ChatMessageView />
      </div>

      {isEditingChat && currentChat.id && <EditChatView chatId={currentChat.id} />}
    </Paper>
  );
};

const ChatMessagesWithContext = () => {
  const { activeChat } = useChatContext();

  if (!activeChat) {
    return null;
  }

  return (
    <ChatMessagesContextProvider chat={activeChat}>
      <ChatMessages />
    </ChatMessagesContextProvider>
  );
};

export default ChatMessagesWithContext;
